import { TFunction } from 'i18next';
import { ModalMode } from './types';

export const getModalTitle = (mode: ModalMode, t: TFunction) => {
  const titles: Record<ModalMode, string> = {
    view: t('contacts.viewContact'),
    edit: t('contacts.editContact'),
    create: t('contacts.createContact')
  };
  return titles[mode];
};

/** The legacy contact form's `maxlength`s; phones follow the `varchar(40)` column, not the DTO's 200. */
export const CONTACT_FIELD_MAX_LENGTH = {
  title: 40,
  name: 255,
  jobTitle: 255,
  address: 255,
  email: 100,
  phone: 40
} as const;
